import React from 'react';
import { Table, Divider, Popconfirm, Button, Typography, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
const { Text } = Typography;
const UploadFileTable = (props) => {
	const {
		pagination,
		dataSource,
		openModal,
		spinner,
		history,
		delete: deleteData,
		modify,
		deleteAccess,
	} = props;

	const { goBack } = history;

	const clickToCopy = (url) => {
		navigator.clipboard.writeText(url);
		message.success('Copied To ClipBoard');
	};

	const column = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			render: (record) => <span>{record}</span>,
		},
		{
			title: 'Module',
			dataIndex: 'module',
			key: 'module',
			render: (record) => <span>{record}</span>,
		},
		{
			title: 'URL',
			dataIndex: 'url',
			key: 'url',
			render: (record) => <span>{record.substring(0, 25)}...</span>,
		},
		{
			title: 'Created On',
			dataIndex: 'createdAt',
			key: 'createdAt',
			render: (record) => <span>{moment(new Date(record)).format('DD/MM/YYYY')}</span>,
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
			render: (_, record) => (
				<div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
					<Button onClick={() => clickToCopy(record.url)}>Click to Copy</Button>
					<a style={{color:"#5c5c5cff"}} onClick={() => props.modify(record)}>Modify</a>
					<Popconfirm
						title="Are you sure delete this file?"
						onConfirm={() => props.delete(record.id)}
						okText="Yes"
						cancelText="No"
					>
						<DeleteOutlined style={{ color: 'gray', cursor: 'pointer', fontSize: '16px' }} title="Delete" />
					</Popconfirm>
				</div>
			),
		},
	];

	return (
		<Table
			rowKey={(record) => record.id}
			pagination={pagination}
			columns={column}
			style={{ cursor: 'pointer' }}
			dataSource={dataSource}
			loading={spinner}
		/>
	);
};

export default withRouter(UploadFileTable);
